var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view',{key:_vm.$route.fullpath}),_c('notifications',{attrs:{"group":"appNotify","position":"bottom center","width":"400px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }